import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';

export default function GatewayPollingInfoComponent({ handleFormChange, selectedGateway }: any) {
  return (
    <>
      {/* <AccordionContainer
        child={ */}
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Interval"
              name="Interval"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Polling.Interval',
                  selectedGateway?.Polling
                )
              }}
              type="number"
              value={selectedGateway?.Polling?.Interval}
            />
            <InputContainer
              label="Duration"
              name="Duration"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Polling.Duration',
                  selectedGateway?.Polling
                )
              }}
              type="number"
              value={selectedGateway?.Polling?.Duration}
            />

          </div>
        {/* }
        expandedPanel="Polling Info"
        headerTitle="Polling Info"
      /> */}
    </>
  )
}